module.exports = __webpack_public_path__ + "static/renovatie_img-789f91b1cc29348746794265afcd516a.jpg";